/** Short disclaimer for footer; full text lives on Help. */
export const DISCLAIMER_SHORT =
  "OnTrack is for education and planning only — not financial, tax, or legal advice.";

export const DISCLAIMER_FULL =
  "OnTrack is for education and planning only. It is not financial, tax, or legal advice. Tax law and product rules change; verify anything important with a qualified adviser and official sources.";
